import adminImg from "../media/adminImg.png"
import { Icon } from "@iconify/react";
import useGenStore from "../store/genstore";
import graphics from "../media/graphic2.jpg"
import useFirebaseStore from "../store/firebasestore";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
function AdminDashboard(){
        const viewOrders = useGenStore((s)=>s.viewOrders)
        const setViewOrders = useGenStore((s)=>s.setViewOrders)
        const setviewAnalytics = useGenStore((s)=>s.setviewAnalytics)
        const AdminName = useFirebaseStore((s)=>s.AdminName)
        const adminOrders = useFirebaseStore((s)=>s.adminOrders)
        const setOrderPopUp = useGenStore((s)=>s.setOrderPopUp)
        const setOrderOnView = useGenStore((s)=>s.setOrderOnView)
        const setOrderStatusOnView = useGenStore((s)=>s.setOrderStatusOnView)

       const showOrderPop = (orderId,status) =>{
            setOrderPopUp(true)
            setOrderOnView(orderId)
            
            setOrderStatusOnView(status)
        }
  const showDelivery = (id) => {
    const sltOrder = adminOrders.find(order => order.id === id);

    if (!sltOrder) {
        Swal.fire({
            title: "Order not found",
            icon: "error"
        });
        return;
    }

    Swal.fire({
        title: sltOrder.destination,
        text: sltOrder.delText,
        icon: "info",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        showCancelButton: false,
        cancelButtonColor: "#6a5acd"
    });
};
    return(
               <div className="adminDashWrapMain">
            <div className={`adwmTop ${viewOrders ? "": "adwmTopActive"}`}>
                <div className="adwmTopLeft">
                    <div className="admwTopLeftImg">
                          <div className="circle-containerAdmin AdminImgContainer">
  <div className="circle-maskAdmin">
    <img src={adminImg} alt="person" className="person-imgAdmin" />
  </div>
  <img src={adminImg} alt="person" className="person-topAdmin" />
</div>
          </div>
                     <div className="adwmTopLeftCont">
                        <p>{AdminName} </p>
                        <button onClick={()=>setViewOrders()}>View Orders</button>
                     </div>
                </div>
                <div className="adwmTopRight">
                    <div className="adwmTopRightCont">
                        <div className="adwmTopRightContLeft">
  <span>View your business progress</span>
  <p>Track orders, sales, and performance insights to understand business growth.</p>
  <button onClick={()=>setviewAnalytics()}>View Analytics</button>
</div>

                        <div className="adwmTopRightContRight">
                            <img src={graphics} alt="" />
                        </div>

                    </div>
                </div>
            </div>
            <div className={`adwmBtm ${viewOrders ? "adwmBtmActive": ""}`}>
                <div className="admPendingOrders">
                    <div className="orderTableTop">
                        <div className="clientName">
                            <p>Client</p>
                        </div>
                        <div className="orderAmount">
                            <p>Amount</p>
                        </div>
                        <div className="orderDate">
                            <p>Date</p>
                        </div>
                        <div className="orderAction">
                            <p>Action</p>
                        </div>
                    </div>
                    <div className="orderTableBtm">
                        {adminOrders.map((order,index)=>(
   <div
   key={order.id}

   className="orderTableRow">
<div className="clientName">
    <p >{order.userName}</p>
  
</div>
                        <div className="orderAmount">
                            <p>Ksh. {order.amount}</p>
                        </div>
                        <div className="orderDate">
                            <p>{order.date}</p>
                        </div>
                        <div className="orderAction">
                            <button onClick={()=>showOrderPop(order.id,order.status)}>View</button>
     <div className="orderActionIcon">
                                <Icon onClick={()=>showDelivery(order.id)} icon="solar:map-point-bold" className="faIcon"/>
                            </div>                       
                             </div>
                        </div>
                        ))}
                     
                         
                    </div>
                </div>
            </div>

        </div>
            

      
    )
}
export default AdminDashboard;